/* __next_internal_client_entry_do_not_use__ DebugInfoSection auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { LazyDebugInfoSection } from "@faire/retailer-visitor-shared/features/MarketplaceItems/MarketplaceProduct/DebugInfo/LazyDebugInfoSection";
import { useUserStore } from "@faire/retailer-visitor-shared/stores/domain/UserStore";
import React, { Suspense } from "react";
export var DebugInfoSection = function(param) {
    var _param_data = param.data, productToken = _param_data.productToken, promotedBy = _param_data.promotedBy, debugInfo = _param_data.debugInfo;
    var _useUserStore = useUserStore([
        "isEmployee",
        "isImpersonating"
    ]), isEmployee = _useUserStore.isEmployee, isImpersonating = _useUserStore.isImpersonating;
    if (!productToken) {
        return null;
    }
    if (!(isEmployee || isImpersonating)) {
        return null;
    }
    return /*#__PURE__*/ _jsx(Suspense, {
        fallback: null,
        children: /*#__PURE__*/ _jsx(LazyDebugInfoSection, {
            productToken: productToken,
            promotedBy: promotedBy,
            debugInfo: debugInfo
        })
    });
};
